export const infoSessionTypes = {
  IN_PERSON: 'In-person',
  VIRTUAL: 'Virtual',
};

export const infoSessionTypesRender = [
  { id: 1, value: 'In-person', label: 'In Person' },
  { id: 2, value: 'Virtual', label: 'Virtual' },
];
